import Option from '@/components/form/types/Option.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { TOGGLE_NO, TOGGLE_YES } from './fieldTypes';
import { EditFieldShape, perFieldInputs } from './editFieldSchema';

/**
 * Napisy i słowniki modala edycji pozycji — jedyne miejsce, w którym te teksty
 * istnieją (reguła z `CLAUDE.md`: komponenty nie budują własnych map).
 */

/**
 * Nazwa typu pola w podtytule okna. Słownik jest częściowy z rozmysłem:
 * `FieldType` ma trzydzieści wartości opisujących kolumny tabel, a modal edycji
 * potrafi postawić kontrolkę pod osiem z nich — reszta nigdy nie trafi do
 * podtytułu i pełny słownik nie miałby drugiego czytelnika.
 */
export const EDIT_FIELD_TYPE_LABELS: Partial<Record<FieldType, string>> = {
  [FieldType.TEXT]: 'Tekst',
  [FieldType.LONG_TEXT]: 'Dłuższy tekst',
  [FieldType.MONEY_VALUE]: 'Kwota',
  [FieldType.DATE]: 'Data',
  [FieldType.DROPDOWN]: 'Wybór z listy',
  [FieldType.MULTISELECT]: 'Wybór wielokrotny',
  [FieldType.CHECKBOX]: 'Pole tak / nie',
  [FieldType.PHONE_NUMBER]: 'Numer telefonu',
};

/** Podtytuł pozycji ręcznej — nie ma typu pola, bo nie jest polem osoby. */
const MANUAL_LINE_TYPE_LABEL = 'Pozycja ręczna';

/**
 * Nazwa tego, co operator edytuje — `null`, gdy nie ma czego dopowiedzieć.
 *
 * Wiersz wielopolowy mówi to samą etykietą („Adres”, „Imię i nazwisko”), więc
 * doklejanie mu typu pojedynczego pola byłoby mylące: adres to trzy pola, a nie
 * jeden tekst.
 */
export const editFieldTypeLabel = ({
  type,
  fields,
  manual,
}: EditFieldShape): string | null => {
  if (manual) {
    return MANUAL_LINE_TYPE_LABEL;
  }
  return perFieldInputs(fields).length > 0
    ? null
    : (EDIT_FIELD_TYPE_LABELS[type] ?? null);
};

export const CHANGE_TOGGLE_OPTIONS: Option[] = [
  { value: TOGGLE_YES, label: TOGGLE_YES },
  { value: TOGGLE_NO, label: TOGGLE_NO },
];

/** Pusty wybór na liście wariantów — odpowiednik „Nie wybrano” z rachunku. */
export const NO_SELECTION_OPTION_VALUE = '';

/**
 * Nazwy nadawane nowej pozycji ręcznej, dopóki operator nie wpisze własnego
 * opisu — brzmią tak samo jak przyciski, z których pozycja przyszła
 * („+ Wolna linia” w sekcji uczestnika, „+ Zniżka” na ekranie rezerwacji).
 */
export const MANUAL_LINE_LABEL = 'Wolna linia';
export const MANUAL_DISCOUNT_LABEL = 'Zniżka';
